import React from "react";
import { Route, Switch } from "react-router-dom";

import Historial from "../../../modules/PersonnelActions/Historial";

export default () => {
  return (
    <Switch>
      <Route exact path="/personnel-actions/histories" component={Historial} />
    </Switch>
  );
};